import React, { Component } from 'react';

// @source
import {
  QueryBuilder,
  Fragment,
  ConvertQuery,
} from '../../../components';

const container = {
  boxSizing: 'border-box',
  minWidth: '100%',
  padding: 15,
  width: 'fit-content',
};

const initialState = {
  fields: [],
};

const postMessage = (message) => {
  if (window.postMessage) {
    window.postMessage(JSON.stringify(message));
  }
};

class MQueryBuilder extends Component {
  constructor(props) {
    super(props);
    this.state = initialState;
    this.handleReceiveMessage = this.handleReceiveMessage.bind(this);
  }

  componentWillMount() {
    document.addEventListener('message', this.handleReceiveMessage);
  }

  handleReceiveMessage({ data }) {
    if (data) {
      const store = JSON.parse(data);

      this.setState(prevState => ({
        fields: store.fields || prevState.fields,
      }));
    }
  }

  render() {
    const { fields, message } = this.state;

    return (
      <Fragment>
        <meta name="viewport" content="width=device-width, initial-scale=1.0, user-scalable=0" />
        <div style={container}>
          <p>{message}</p>
          {fields.length ? (
            <QueryBuilder
              isMobile
              fields={fields}
              output={(template) => {
                const query = ConvertQuery(template);
                postMessage({ query });
              }}
            />
          ) : null}
        </div>
      </Fragment>
    );
  }
}

export default MQueryBuilder;
